import React from "react";
import style from './CustomFalseCeiling.module.scss';
import CustomFalseCeilingLegends from "./CustomFalseCeilingLegends";
import CustomSOWView from "./CustomSOWView";

const TavViewSection = (props: any) => {
  const { details, index, isDrawingsExporting, updateDetails, itemDetails } = props;

  return (
    <div key={index}>
      <div className={style.sub_tab_section}>
        <h4 className="sub_tab_heading">
          {details?.label}
        </h4>
        <div className={style.sub_tab_options}>
          {
            details?.id === 'legend'
              ?
              <CustomFalseCeilingLegends />
              :
              details?.id === 'sow_hl_scope'
                ?
                <CustomSOWView details={details} itemDetails={itemDetails} updateDetails={(e) => updateDetails(e)} />
                :
                details?.options?.map((e: any, i: any) => (
                  <div className={style.sub_value_tab} key={i}>
                    {e.label ? <p className={style.sub_label}>{e.label}</p> : ''}
                    <div className={style.sub_value}>
                      {
                        e?.type === 'option' && !isDrawingsExporting ? <select className={style.edit_select_options} onChange={(v) => updateDetails({ id: e.id, value: v.target.value })}>
                          <option value=""></option>
                          {
                            e?.options?.map((o: any) => <option value={o} selected={itemDetails?.[e.id] === o}>{o}</option>)
                          }
                        </select>
                          : e?.type === 'input' && !isDrawingsExporting ? <input value={itemDetails?.[e.id] || ''} className={style.edit_input_value} onChange={(v) => updateDetails({ id: e.id, value: v.target.value })} />
                            : <p>{itemDetails?.[e.id] || '-'}</p>
                      }
                    </div>
                  </div>
                ))
          }
        </div>
      </div>
    </div>
  )
}

export default TavViewSection;